import { useCityInfoStore } from '~/stores/useCityInfo'

export default defineNuxtPlugin(() => {
  const { hostname } = useRequestURL() // 获取请求头

  /**
   * 打开项目时初始化城市列表
   */
  const store = useCityInfoStore()
  store.setCityInfo(hostname)
})
